/*========================================================

THEME: RecordLatheParts.com
FILE: theme-overrides.js
CREATED BY: Greyforest.media

========================================================*/

// MOBILE MENU TOGGLE
$('#ToggleMobileMenu').on('click', function (evt) {
  evt.preventDefault();
  $(this).toggleClass('open');
  $('#SiteNav').slideToggle();
});




// MOBILE MENU TOGGLE
$('body').on('click','.contact-form-trigger', function (evt) {
  evt.preventDefault();
  $('#shopify-section-theme-contact-form').toggleClass('active');
});


// MOBILE MENU TOGGLE
$(document).ready( function (evt) {
  if ( $('#contact_form .errors').length ) {
  $('#shopify-section-theme-contact-form').addClass('active');
  }
});